<template>
  <main class="page-operative page-operative-project-library page-operative-project-library-expense page-operative-project-library-expense-new">
    <div class="container">
      <div class="d-flex align-items-center justify-content-between mb-5">
        <PageTitle>Nuovo costo figurato (libreria)</PageTitle>
        <app-router-link class="btn btn-outline-primary" :to="{ name: 'operative-company.projects.library.imputedCosts.list' }">Torna alla lista</app-router-link>
      </div>

      <FormImputedCost v-if="company && userCanEdit" @saved="saveCosto" />
      <div v-else-if="company">Utente non abilitato</div>
    </div>
  </main>
</template>

<script>

import operativePageMixin from '@/mixins/operativePage';

export default {
  name: 'page-operative-company-project-library-expense-new',
  mixins: [operativePageMixin],
  components: {
    PageTitle: () => import('@/views/components/Layout/LayoutOperative/PageTitle'),
    FormImputedCost: () => import('@/views/components/Operative/Form/FormImputedCost'),
    AppRouterLink: () => import('@/views/components/Layout/AppRouterLink'),
  },
  methods: {
    saveCosto (costo) {
      this.$api.addImputedCost(this.company.id, costo)
        .then(() => {
          this.$router.push({
            name: 'operative-company.projects.library.imputedCosts.list',
            query: {
              forecast: this.$route.query?.forecast || null,
            },
          });
        })
        .catch(this.$log.error)
      ;
    },
  },
};

</script>
